var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.race)?_c('div',{staticClass:"ims-standings"},[_vm._v(_vm._s(_vm.race.name)+" standings")]):_c('div',[_vm._v(" Unable to load "),_c('strong',[_vm._v(_vm._s(_vm.$User.profile.teamName)+"'s")]),_vm._v(" rank for this race ")])}
var staticRenderFns = []

export { render, staticRenderFns }